import { createRouter, createWebHistory } from 'vue-router'
import Home from '../views/home/Home.vue'
import Login from '../views/login/Login.vue'
import NotFound from '../views/error-page/404.vue'
import Culture from '../views/culture/Culture.vue'
import Persons from '../views/persons/Persons.vue'
import Integrity from '../views/integrity/Integrity.vue'
import History from '../views/history/History.vue'
// import Education from '../views/education/Education.vue'
import Solutions from '../views/solutions/Solutions.vue'
import Structure from '../views/structure/Structure.vue'
import Okrs from '../views/okrs/Okrs.vue'
import Dna from '../views/dna/Dna.vue'
import ChangePassword from '../views/changePassword/changePassword.vue'
// import store from '../store/index'

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
    // meta: {
    //   requiresUnAuth: true
    // }
  },
  {
    path: '/auth',
    name: 'Signin',
    component: Login
    // meta: {
    //   requiresUnAuth: true
    // }
  },
  {
    path: '/cultura',
    name: 'Cultura',
    component: Culture
    // meta: {
    //   requiresAuth: true
    // }
  },
  {
    path: '/historia',
    name: 'História',
    component: History
    // meta: {
    //   requiresAuth: true
    // }
  },
  {
    path: '/gestao-pessoas',
    name: 'Gestão de Pessoas',
    component: Persons
    // meta: {
    //   requiresAuth: true
    // }
  },
  {
    path: '/programa-integridade',
    name: 'Programa de Integridade',
    component: Integrity
    // meta: {
    //   requiresAuth: true
    // }
  },
  // {
  //   path: '/educa-pixeon',
  //   name: 'Educa Pixeon',
  //   component: Education
  //   meta: {
  //     requiresAuth: true
  //   }
  // },
  {
    path: '/solucoes',
    name: 'Soluções',
    component: Solutions
    // meta: {
    //   requiresAuth: true
    // }
  },
  {
    path: '/estrutura',
    name: 'Estrutura',
    component: Structure
    // meta: {
    //   requiresAuth: true
    // }
  },
  {
    path: '/okrs',
    name: 'Okrs',
    component: Okrs
    // meta: {
    //   requiresAuth: true
    // }
  },
  {
    path: '/dna',
    name: 'DNA',
    component: Dna
    // meta: {
    //   requiresAuth: true
    // }
  },
  {
    path: '/mudar-senha',
    name: 'Mudar Senha',
    component: ChangePassword
    // meta: {
    //   requiresAuth: true
    // }
  },
  { path: '/:pathMatch(.*)*', name: 'NotFound', component: NotFound }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

// router.beforeEach((to, _, next) => {
//   const authenticated = store.getters.isAuthenticated

//   if (to.meta.requiresAuth && !authenticated) {
//     next('/auth')
//   } else if (to.meta.requiresUnAuth && authenticated) {
//     next('/cultura')
//   } else {
//     next()
//   }
// })

export default router
